export interface MenuItem {
  name: string
  className?: string
  samePage?: boolean
  link?: string
  sectionClassName?: string
}

export const enum MenuAnchor {
  Capabilities = 'anchor-capabilities',
  Philosophy = 'anchor-philosophy',
  Skills = 'anchor-skills',
  Portfolio = 'anchor-portfolio',
  Opensource = 'anchor-opensource',
  About = 'anchor-about',
  Contact = 'anchor-contact',
}

export const MenuItems: MenuItem[] = [
  { name: 'Capabilities', link: '/', samePage: true, sectionClassName: MenuAnchor.Capabilities },
  // { name: 'Portfolio', link: '/', samePage: true, sectionClassName: MenuAnchor.Portfolio },
  { name: 'About Me', link: '/', samePage: true, sectionClassName: MenuAnchor.About },
  { name: 'Contact', link: '/', samePage: true, sectionClassName: MenuAnchor.Contact },
]

export const HeroCTAMenu: MenuItem[] = [
  { name: 'Portfolio', link: '/', samePage: true, sectionClassName: MenuAnchor.Skills },
  { name: 'How I Think', link: '/', samePage: true, sectionClassName: MenuAnchor.Philosophy },
]
